// extracted by mini-css-extract-plugin
export default {"progress-archive-warning":"styles_progress-archive-warning__H2nKi"};